<form #formElement="ngForm" class="moneto-finalize">
  <app-account-information [form]="formElement"></app-account-information>

  <!-- <app-pdf-access></app-pdf-access> -->

  <!-- <app-terms [lang]="language"></app-terms> -->

  <div class="mt-2">
    <app-checkbox-control [form]="formElement" [control]="signCertified"></app-checkbox-control>
  </div>

  <div class="mt-2  mb-5">
    <app-checkbox-control [form]="formElement" [control]="terms"></app-checkbox-control>
  </div>
</form>
